import { Quantity } from "./Quantity";
import { ShakeButton } from "./ShakeButton";

interface ControlsProps {
  selectedSpice: number | null;
  onShake: () => void;
  className?: string;
}

export function Controls({
  selectedSpice,
  onShake,
  className = "",
}: ControlsProps) {
  return (
    <div className={`w-full flex flex-col gap-10 ${className}`}>
      <div className="controls-core bg-primary border-t lg:border-t-0 lg:bg-primary">
        <Quantity selectedSpice={selectedSpice} />
        <ShakeButton onShake={onShake} disabled={selectedSpice === null} />
      </div>
    </div>
  );
}
